var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 2000,
    height: 2000,
    viewBox: "0 0 529.167 529.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    display: "inline",
    opacity: 1,
    transform: "translate(0 232.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4531",
    fill: "#065876",
    strokeWidth: 3.692,
    d: "M884.49 249.707a585.274 594.366 0 0 0-585.273 594.365 585.274 594.366 0 0 0 585.273 594.366 585.274 594.366 0 0 0 567.655-452.153h-172.739a419.516 426.033 0 0 1-394.916 283.82 419.516 426.033 0 0 1-419.515-426.033A419.516 426.033 0 0 1 884.49 418.04a419.516 426.033 0 0 1 396.434 288.246h172.219A585.274 594.366 0 0 0 884.49 249.707",
    transform: "matrix(.26458 0 0 .26458 0 -232.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse4642",
    fill: "#e87e30",
    strokeWidth: 1.831,
    d: "M884.49 549.348a290.217 294.725 0 0 0-290.217 294.724 290.217 294.725 0 0 0 290.217 294.725 290.217 294.725 0 0 0 290.217-294.725A290.217 294.725 0 0 0 884.49 549.348m0 135.394a156.892 159.33 0 0 1 156.893 159.33A156.892 159.33 0 0 1 884.49 1003.4a156.892 159.33 0 0 1-156.892-159.328 156.892 159.33 0 0 1 156.892-159.33",
    opacity: 1,
    transform: "matrix(.26458 0 0 .26458 0 -232.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse4647",
    fill: "#065876",
    strokeWidth: 3.692,
    d: "M1461.648 418.285v288h167.61v-288zm0 568v186.572c-3.7 109.892-49.254 214.034-127.07 290.489s-181.816 119.253-290.09 119.377c-110.827 0-217.113-44.71-295.48-124.293-56.392-57.268-95.001-129.217-112.22-207.002H466.442c19.227 123.155 76.276 237.924 164.196 327.209 109.76 111.465 258.627 174.086 413.851 174.086 152.694-.088 299.309-60.774 408.559-169.108s172.484-255.738 176.209-410.758V986.285Z",
    display: "inline",
    opacity: 1,
    transform: "matrix(.26458 0 0 .26458 0 -232.167)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCj);
export default __webpack_public_path__ + "static/media/cj.24beefa194e83445ff94b44df29bd8cf.svg";
export { ForwardRef as ReactComponent };